module.exports = __webpack_public_path__ + "img/wang2.e78c8508.png";